import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"close\">\n  <path fill=\"#352C0B\" fill-rule=\"evenodd\" d=\"m82.5 8.665-2.12-2.121-36.066 36.065L10.37 8.666l-2.12 2.122L42.193 44.73 8.253 78.67l2.122 2.121 33.939-33.939 36.06 36.061 2.122-2.12-36.06-36.062L82.5 8.665Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol